export function useUtils() {
    const saveFile =  (blob:Blob, fileName:string)  => {
        const a:HTMLAnchorElement = document.createElement("a");
        document.body.appendChild(a);
        a.style.display = "none";
        let url = window.URL.createObjectURL(blob);
        a.href = url;
        a.download = fileName;
        a.click();
        window.URL.revokeObjectURL(url);
    };

    const priceToTaxExcl = (price) => {
        const tva = useRuntimeConfig().public.tvaRate; //
        return (price / (1 + (tva / 100))).toFixed(2)
    }

    return {saveFile, priceToTaxExcl}


}
